import * as React from 'react';

const BoardsLink = ({ onBoardClick, board = 4, totalBoards = 4, ...props }) => {
  const handleGroupClick = (boardId) => {
    console.log({ boardId })
    if (onBoardClick) {
      onBoardClick(boardId);
    }
  };
  console.log({ totalBoards })

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={533.786}
      height={117.333}
      viewBox="0 0 141.231 31.044"
      {...props}
    >
      <g transform="translate(-109.216 -100.44)">
        {/* --- BACKGROUND DECORATIONS (Lines & Dots) --- */}

        {/* --- CLICKABLE GROUPS --- */}


        {/* BOARD 1 GROUP */}
        <g onClick={() => {
          if (board === 1) {
            return;
          }
          handleGroupClick(board - 1)
        }} style={{ cursor: board === 1 ? 'auto' : 'pointer' }}>
          <circle cx={142.119} cy={101.557} r={1.117} style={{ fill: "#000", stroke: "none", strokeWidth: 0.3, strokeDasharray: "1.2,.600001" }} />
          <circle cx={142.272} cy={115.847} r={1.117} style={{ fill: "#000", stroke: "none", strokeWidth: 0.3, strokeDasharray: "1.2,.600001" }} />
          <path d="M142.133 103.553c0 12.748.227 12.748.227 12.748" style={{ fill: "none", stroke: "#000", strokeWidth: 0.477675, strokeDasharray: "1.9107,.955352" }} />
          <rect
            width={20.672}
            height={15.766}
            x={132.2}
            y={115.638}
            rx={3.121}
            ry={3.121}
            style={{
              fill: "transparent", // Changed from "none"
              stroke: "#0a5da6",
              strokeWidth: 0.233788,
              strokeDasharray: ".935153,.467577",
            }}
          />
          <text
            xmlSpace="preserve"
            x={114.819}
            y={124.954}
            style={{
              fontStyle: "normal", fontWeight: 400, fontSize: "4px", fontFamily: "Roboto, Helvetica, Arial, sans-serif", fill: "none", stroke: "#0a5da6", strokeWidth: 0.4, strokeDasharray: "1.6,.800002",
              pointerEvents: "none"
            }}
          >
            <tspan x={134.819} y={124.954} style={{ fontWeight: 700, fill: "#000", stroke: "none" }}>
              {board === 1 ? "Reader" : `Board ${board - 1}`}
            </tspan>
          </text>
        </g>

        {/* BOARD 2 GROUP */}
        {board > 1 && <g onClick={() => {
          if (board === 2) {
            return;
          }
          handleGroupClick(2)
        }} style={{ cursor: board === 2 ? 'auto' : 'pointer' }}>
          <circle cx={-123.424} cy={152.934} r={1.117} transform="rotate(-90)" style={{ fill: "#000", stroke: "none", strokeWidth: 0.3, strokeDasharray: "1.2,.600001" }} />
          <circle cx={-123.271} cy={161.5} r={1.117} transform="rotate(-90)" style={{ fill: "#000", stroke: "none", strokeWidth: 0.3, strokeDasharray: "1.2,.600001" }} />
          <path d="M153.46 123.425c7.269 0 7.269-.256 7.269-.256" style={{ fill: "none", stroke: "#000", strokeWidth: 0.38248, strokeDasharray: "1.52992,.764962" }} />

          <rect
            width={20.672}
            height={15.766}
            x={161.432}
            y={115.601}
            rx={3.121}
            ry={3.121}
            style={{
              fill: "transparent", // Changed from "none"
              stroke: "#0a5da6",
              strokeWidth: 0.233788,
              strokeDasharray: ".935153,.467577",
            }}
          />
          <text
            xmlSpace="preserve"
            x={151.596}
            y={124.917}
            style={{
              fontStyle: "normal", fontWeight: 400, fontSize: "4px", fontFamily: "Roboto, Helvetica, Arial, sans-serif", fill: "none", stroke: "#0a5da6", strokeWidth: 0.4, strokeDasharray: "1.6,.800002",
              pointerEvents: "none"
            }}
          >
            <tspan x={164} y={124.917} style={{ fontWeight: 700, fill: "#000", stroke: "none" }}>
              {board === 2 ? "Reader" : `Board ${board - 2}`}
            </tspan>
          </text>
        </g>}

        {/* BOARD 3 GROUP */}
        {board > 2 && <g onClick={() => {
          if (board === 3) {
            return;
          }
          handleGroupClick(1)
        }} style={{ cursor: board === 3 ? 'auto' : 'pointer' }}>
          <circle cx={-123.387} cy={182.21} r={1.117} transform="rotate(-90)" style={{ fill: "#000", stroke: "none", strokeWidth: 0.3, strokeDasharray: "1.2,.600001" }} />
          <circle cx={-123.234} cy={191.15} r={1.117} transform="rotate(-90)" style={{ fill: "#000", stroke: "none", strokeWidth: 0.3, strokeDasharray: "1.2,.600001" }} />
          <path d="M183.237 123.388c7.269 0 7.269-.255 7.269-.255" style={{ fill: "none", stroke: "#000", strokeWidth: 0.38248, strokeDasharray: "1.52992,.764962" }} />

          <rect
            width={20.672}
            height={15.766}
            x={191.002}
            y={115.475}
            rx={3.121}
            ry={3.121}
            style={{
              fill: "transparent", // Changed from "none"
              stroke: "#0a5da6",
              strokeWidth: 0.233788,
              strokeDasharray: ".935153,.467577",
            }}
          />
          <text
            xmlSpace="preserve"
            x={188.165}
            y={124.792}
            style={{
              fontStyle: "normal", fontWeight: 400, fontSize: "4px", fontFamily: "Roboto, Helvetica, Arial, sans-serif", fill: "none", stroke: "#0a5da6", strokeWidth: 0.4, strokeDasharray: "1.6,.800002",
              pointerEvents: "none"
            }}
          >
            <tspan x={193.5} y={124.792} style={{ fontWeight: 700, fill: "#000", stroke: "none" }}>
              {board === 3 ? "Reader" : `Board ${board - 3}`}
            </tspan>
          </text>
        </g>}

        {/* READER GROUP */}
        {board > 3 && <g onClick={() => {
          if (board === 4) {
            return;
          }
          handleGroupClick('Reader')
        }} style={{ cursor: board === 4 ? 'auto' : 'pointer' }}>
          <circle cx={-123.262} cy={211.779} r={1.117} transform="rotate(-90)" style={{ fill: "#000", stroke: "none", strokeWidth: 0.3, strokeDasharray: "1.2,.600001" }} />
          <circle cx={-123.109} cy={220.72} r={1.117} transform="rotate(-90)" style={{ fill: "#000", stroke: "none", strokeWidth: 0.3, strokeDasharray: "1.2,.600001" }} />
          <path d="M212.807 123.262c7.269 0 7.269-.255 7.269-.255" style={{ fill: "none", stroke: "#000", strokeWidth: 0.38248, strokeDasharray: "1.52992,.764962" }} />

          <rect
            width={20.672}
            height={15.766}
            x={220.757}
            y={115.482}
            rx={3.121}
            ry={3.121}
            style={{
              fill: "transparent", // Changed from "none"
              stroke: "#0a5da6",
              strokeWidth: 0.233788,
              strokeDasharray: ".935153,.467577",
            }}
          />
          <text
            xmlSpace="preserve"
            x={224.921}
            y={124.799}
            style={{
              fontStyle: "normal", fontWeight: 400, fontSize: "4px", fontFamily: "Roboto, Helvetica, Arial, sans-serif", fill: "none", stroke: "#0a5da6", strokeWidth: 0.4, strokeDasharray: "1.6,.800002",
              pointerEvents: "none"
            }}
          >
            <tspan x={224} y={124.799} style={{ fontWeight: 700, fill: "#000", stroke: "none" }}>
              {board === 4 ? "Reader" : `Board ${board - 4}`}
            </tspan>
          </text>
        </g>}

      </g>
    </svg >
  );
};

export default BoardsLink;